export const ADD_SELECTED_LAYER_TO_PRINT = 'ADD_SELECTED_LAYER_TO_PRINT';
export const REMOVE_SELECTED_LAYER_FROM_PRINT = 'REMOVE_SELECTED_LAYER_FROM_PRINT';

export const SET_SELECTED_BASE_LAYER_PRINT = 'SET_SELECTED_BASE_LAYER_PRINT';